import React from 'react';

const Forward = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 14 14"
  >
    <path
      fill="#FFF"
      d="M9.551 6.804l-7.955 5.032C.918 12.266 0 11.798 0 11.027V.975C0 .19.918-.265 1.596.165l7.955 5.033a.942.942 0 010 1.606zM12 12c-.552 0-1-.614-1-1.371V1.37C11 .614 11.448 0 12 0s1 .614 1 1.371v9.258c0 .757-.448 1.371-1 1.371z"
    />
  </svg>
);

export default Forward;
